import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericContainer} from "../../../components/containers/GenericContainer";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {userRoleService} from "../../../jwt/_services";
import {userProvider} from "../../../providers/userProvider";

const RoleUserSection = (props) => {
    const path = props.path + "/users";

    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [userId, setUserId] = useState(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);


    useEffect(() => {
        const dataRequest = {
            role: { id: domainObject?.id }
        };

        genericIndexedActions.search(path, userRoleService, 0, 1000, dataRequest);
    }, []);

    const onAdd = () => {
        const dataRequest = {
            user: { id: userId },
            role: { id: domainObject?.id }
        }

        genericIndexedActions.add(path, userRoleService, dataRequest);
    };


    const onRemove = ( _userRole ) => {
        const dataRequest = {
            role: { id: domainObject?.id  },
            user: { id: _userRole?.user?.id }
        }

        genericIndexedActions.remove(path, userRoleService, dataRequest);
    };

    const renderContent = ( _option ) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3>{ (_option?.user?.name || '') + ' ' + (_option?.user?.lastName || '')  }</h3>
                </label>
                <div className="float-right">
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={'Desvincular'}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={_ => onRemove(_option)}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            {/*GENERIC CONTAINER VINCULAR*/}
            <GenericContainer
                titlle={'Usuarios en este rol'}
                listItems={listDomainObjects}
                renderContent={renderContent}
                loading={loading}

                provider={userProvider}
                option={userId}
                setOption={setUserId}
                onAddItem={onAdd}
            />
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(RoleUserSection);
